import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children"];
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';

/** Should only be used in unit tests */
import { jsx as _jsx } from "react/jsx-runtime";
export const TEST_ID = 'import-message-container';
export default function MessageContainer(_ref) {
  let {
      children
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(Flex, Object.assign({}, props, {
    "data-test-id": TEST_ID,
    children: /*#__PURE__*/_jsx(Text, {
      as: "div",
      children: children
    })
  }));
}